import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';

import Grid from '@mui/material/Grid';
import Main from 'layouts/Main';

// import p1 from 'assests/Photos/ClassAssembly/2024/12C/1.jpg';
// import p2 from 'assests/Photos/ClassAssembly/2024/12C/2.jpg';
// import p3 from 'assests/Photos/ClassAssembly/2024/12C/3.jpg';
// import p4 from 'assests/Photos/ClassAssembly/2024/12C/4.jpg';

// import p5 from 'assests/Photos/ClassAssembly/2024/12A/5.jpg';
// import p6 from 'assests/Photos/ClassAssembly/2024/12A/6.jpg';
// import p7 from 'assests/Photos/ClassAssembly/2024/12A/7.jpg';

import { Typography } from '@mui/material';
import Container from 'components/Container';
import Archive2022 from '../ClassAssembly2023/Archive2022';
import Box from '@mui/material/Box';
import ClassAssemblySidebar2025 from '../ClassAssemblySidebar2025';
import PreprimarySidebar2025 from '../PreprimarySidebar2025/PreprimarySidebar2025';


const NationalCulture2025 = () => {
  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });



  const [config, setConfig] = useState({ base_image_url_2025: '' });
  useEffect(() => {
    fetch('/config.json')  // For Gatsby, this will resolve to /config.json from the static folder
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);
  
  const p1 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/1.webp`;
  const p2 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/2.webp`;
  const p3 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/3.webp`;
  const p4 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/4.webp`;
  const p5 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/5.webp`;
  const p6 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/6.webp`;
  const p7 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/7.webp`;
  const p8 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/8.webp`;
  const p9 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/9.webp`;
  const p10 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/10.webp`;
  const p11 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/11.webp`;
const p12 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/12.webp`;
const p13 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/13.webp`;
const p14 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/14.webp`;
const p15 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/15.webp`;
const p16 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/16.webp`;
const p17 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/17.webp`;
const p18 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/18.webp`;
const p19 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/19.webp`;
const p20 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/20.webp`;
const p21 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/21.webp`;
const p22 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/22.webp`;
const p23 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/23.webp`;
const p24 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/24.webp`;
const p25 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/25.webp`;
const p26 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/26.webp`;
const p27 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/27.webp`;
const p28 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/28.webp`;
const p29 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/29.webp`;
const p30 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/30.webp`;
const p31 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/31.webp`;
const p32 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/32.webp`;
const p33 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/33.webp`;
const p34 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/34.webp`;
const p35 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/35.webp`;
const p36 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/36.webp`;
const p37 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/37.webp`;
const p38 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/38.webp`;
const p39 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/39.webp`;
const p40 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/40.webp`;
const p41 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/41.webp`;
const p42 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/42.webp`;
const p43 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/43.webp`;
const p44 = `${config.base_image_url_2025}/home/events-activities/pre-primary/NationalCelebrations/44.webp`;

 

  const photos = [
    
{
    src: p1,
    source: p1,
    rows: 1,
    cols: 1,
},
{
    src: p2,
    source: p2,
    rows: 1,
    cols: 1,
},
{
    src: p3,
    source: p3,
    rows: 1,
    cols: 1,
},
{
    src: p4,
    source: p4,
    rows: 1,
    cols: 1,
},
{
    src: p5,
    source: p5,
    rows: 1,
    cols: 1,
},
{
    src: p6,
    source: p6,
    rows: 1,
    cols: 1,
},
{
    src: p7,
    source: p7,
    rows: 1,
    cols: 1,
},
{
    src: p8,
    source: p8,
    rows: 1,
    cols: 1,
},
{
    src: p9,
    source: p9,
    rows: 1,
    cols: 1,
},
{
    src: p10,
    source: p10,
    rows: 1,
    cols: 1,
},
{
    src: p11,
    source: p11,
    rows: 1,
    cols: 1,
},
{
    src: p12,
    source: p12,
    rows: 1,
    cols: 1,
},
{
    src: p13,
    source: p13,
    rows: 1,
    cols: 1,
},
{
    src: p14,
    source: p14,
    rows: 1,
    cols: 1,
},
{
    src: p15,
    source: p15,
    rows: 1,
    cols: 1,
},
{
    src: p16,
    source: p16,
    rows: 1,
    cols: 1,
},
{
    src: p17,
    source: p17,
    rows: 1,
    cols: 1,
},
{
    src: p18,
    source: p18,
    rows: 1,
    cols: 1,
},
{
    src: p19,
    source: p19,
    rows: 1,
    cols: 1,
},
{
    src: p20,
    source: p20,
    rows: 1,
    cols: 1,
},
{
    src: p21,
    source: p21,
    rows: 1,
    cols: 1,
},
{
    src: p22,
    source: p22,
    rows: 1,
    cols: 1,
},
{
    src: p23,
    source: p23,
    rows: 1,
    cols: 1,
},
{
    src: p24,
    source: p24,
    rows: 1,
    cols: 1,
},
{
    src: p25,
    source: p25,
    rows: 1,
    cols: 1,
},
{
    src: p26,
    source: p26,
    rows: 1,
    cols: 1,
},
{
    src: p27,
    source: p27,
    rows: 1,
    cols: 1,
},
{
    src: p28,
    source: p28,
    rows: 1,
    cols: 1,
},
{
    src: p29,
    source: p29,
    rows: 1,
    cols: 1,
},
{
    src: p30,
    source: p30,
    rows: 1,
    cols: 1,
},
{
    src: p31,
    source: p31,
    rows: 1,
    cols: 1,
},
{
    src: p32,
    source: p32,
    rows: 1,
    cols: 1,
},
{
    src: p33,
    source: p33,
    rows: 1,
    cols: 1,
},
{
    src: p34,
    source: p34,
    rows: 1,
    cols: 1,
},
{
    src: p35,
    source: p35,
    rows: 1,
    cols: 1,
},
{
    src: p36,
    source: p36,
    rows: 1,
    cols: 1,
},
{
    src: p37,
    source: p37,
    rows: 1,
    cols: 1,
},
{
    src: p38,
    source: p38,
    rows: 1,
    cols: 1,
},
{
    src: p39,
    source: p39,
    rows: 1,
    cols: 1,
},
{
    src: p40,
    source: p40,
    rows: 1,
    cols: 1,
},
{
    src: p41,
    source: p41,
    rows: 1,
    cols: 1,
},
{
    src: p42,
    source: p42,
    rows: 1,
    cols: 1,
},
{
    src: p43,
    source: p43,
    rows: 1,
    cols: 1,
},
{
    src: p44,
    source: p44,
    rows: 1,
    cols: 1,
}


    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Main>
        <Container>
    <Grid container spacing={4}>
            <Grid item xs={12} md={8}>
    <Box>
        
      <Box >
      <Typography variant='h4' align='center'>
      Independence Day and Ganesha Making Activity
        </Typography>
        <Typography
        fontSize = "x-small"
        ><br/><br/>
     Class: PRE-PRIMARY Date: 20 & 22 August 2025  

        </Typography>
        <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Tell me and I forget, teach me and I may remember, involve me and I learn. – Benjamin Franklin”

<br/>
        </Typography>

        <br />
        <Typography variant={'subtitle1'} align={'justify'}>
        At National Public School, Yeshwanthpur, we believe that every experience—big or small—can be transformed into a mighty learning opportunity. Festivals and National days are not just occasions of celebration, they are valuable moments where children explore, discover and learn in ways that are joyful, meaningful and lasting. The recent Independence Day and Ganesha Chaturthi celebrations at Pre-Primary beautifully reflected this philosophy.
       <br></br>
       <br></br>
        <strong>Independence Day Celebrations</strong> 
        <br></br>
        Our youngest learners stepped into the spirit of the nation with great enthusiasm. Dressed in the vibrant hues of the tricolour, they proudly honoured the essence of freedom and unity. Through interactive sessions, the children were introduced to India’s national symbols, learning to recognise and appreciate the pride they carry.
        A special highlight was when the children joyfully stood together in the formation of the national symbols—a moment that not only made for a memorable photograph but also helped instill in them values of patriotism, identity and togetherness. Such age-appropriate activities nurtured their memory skills, observation and sense of belonging, making the day both educational and heart-warming.
        <br></br>
        <br></br>
        <strong>Ganesha Celebrations with Natural Clay</strong>
       <br></br>
        In preparation for Ganesha Chaturthi, children experienced the magic of creating with their own hands. Using eco-friendly natural clay, they moulded Lord Ganesha and his traditional accessories in small groups. The outdoor session was filled with laughter, curiosity and collaboration as little hands came together to build and design.
        This joyful hands-on activity not only encouraged fine motor development, sensory exploration and creativity, but also introduced children to the importance of eco-conscious celebrations. Working in groups fostered values of sharing, teamwork, and mutual appreciation, leaving every child proud of their clay Ganesha creation.
       <br></br>
       <br></br>
        <strong>Learning Beyond Festivities</strong>
        <br></br>
        At National Public School, Yeshwanthpur, such celebrations are more than just events—they are learning journeys woven into the fabric of early education. Through Independence Day activities, children embraced national pride, while the Ganesha clay sessions nurtured cultural understanding and creativity. Together, these experiences helped children grow in confidence, communication and social-emotional skills, while enjoying the essence of festivity.
        For our little learners, these special days became an exploration of joy, discovery and values—reminding us that in the early years, every celebration is a classroom and every moment is a chance to learn.
        <br></br>
        <br></br>
        “Every little celebration is a shining milestone in a child’s journey of growth
         Through colours that sparkle, songs that echo and laughter that fills the air
         Children discover that life is woven with joy, gratitude, and togetherness
         What may seem like simple moments bloom into cherished memories
         Nurturing confidence, kindness and a radiant love for learning that lasts a lifetime”. 
        <br></br>
        </Typography>
      </Box>
      <Typography
          variant={'h6'}
          color={'primary'}
          align={'center'}
          fontWeight={'normal'}
        ><br/>
   “Learning shines brightest when wrapped in celebration.”

<br/>
        </Typography>

    <Box>
        <ImageList
          variant="quilted"
          cols={2}
          rowHeight={isMd ? 200 : 100}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              /> 
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
    </Grid>
    <Grid item xs={12} md={4}>
             
             <Box marginBottom={4}>
               <PreprimarySidebar2025 />
             </Box>
         </Grid>
    </Grid> 
    </Container>
    </Main>
   
  );
};

export default NationalCulture2025;